<header id="parmed-header" class="header">
  <div *ngIf="websiteName == 'Major'" [ngClass]="{'paddingMajor':websiteName=='Major'}"  class="header-major-logo" [routerLink]="['/']">
    <a id="logo">
      <img src="/assets/images/Major/MajorLogonew.png" width="274px" height="40" alt="Major Pharmaceuticals Rugby Laboratories" title=""
      />
    </a>

    <!-- <div id="active-major" [ngClass]="{'active-account': authenticated && (defaultAccount.division === 'Major')}" class="active-major-style"
      data-toggle="tooltip" data-placement="bottom" title="Major Pharmaceuticals">
      <img src="/assets/images/Major/major-accountlogo.png" width="143px" height="40" alt="Major Pharmaceuticals" />
    </div>
    <div id="active-rugby" [ngClass]="{'active-account': authenticated && (defaultAccount.division === 'Rugby')}" class="active-rugby-style"
      data-toggle="tooltip" data-placement="bottom" title="Rugby Laboratories">
      <img src="/assets/images/Major/rugby-accountlogo.png" width="113px" height="40px" alt="Rugby Laboratories" />
    </div> -->
  </div>
  <div *ngIf="websiteName == 'Parmed'" class="header-logo">
    <a id="logo" [routerLink]="['/']" class="margin-bottom-0">
      <img src="/assets/images/parmed-pharmaceuticals-logo.png" width="190" height="60" alt="ParMed Pharmaceuticals" title="ParMed Pharmaceuticals"
      />
    </a>
  </div>
  <div class="header-right" [ngClass]="{'user-info paddingRightMajor': websiteName === 'Major' && authenticated,'paddingMajor': websiteName === 'Major' && !authenticated}" >
       <div *ngIf="!authenticated" [ngClass]="{'header-contentAlign': websiteName === 'Major' }">
      <div *ngIf="websiteName == 'Parmed'" class="center-align" id="website-help" [routerLink]="[routes.websiteHelp]">
        <img height="36px" width="38px" src="/assets/images/question-mark.png" class="vertical-middle padding-right-5" />
        <div class="d-inline-block padding-left-0">Website Help</div>
      </div>
      <div class="center-align" id="sign-in" *ngIf="!authenticated && websiteName == 'Parmed'" (click)="onSignInClick()">
        <img height="36px" width="38px" src="/assets/images/sign-in-logo.png" class="vertical-middle padding-right-5" />
        <div class="d-inline-block padding-left-0">Sign In</div>
      </div>
      <button id="register" *ngIf="!authenticated && websiteName =='Parmed'" mat-raised-button color="accent" class="action-button register-button" [routerLink]="[routes.register]">
        REGISTER NOW
      </button>
      <div class="center-align " id="sign-in" *ngIf="!authenticated && websiteName == 'Major' " >
        <button  style="padding-left: 10px !important;padding-right: 10px !important;" color="accent" mat-raised-button class=" d-inline-block padding-left-0 signin-btn"  (click)="onSignInClick()">
        <mat-icon>person</mat-icon> Sign In</button>
      </div>
      <div  *ngIf="websiteName == 'Major' && !authenticated" class="register-allign" >
        <span class="newcustomer-text">New Customer?</span> <br>
        <span class="starthere-text" [routerLink]="[routes.register]">Register</span><span class="spanFont">to get started.</span>
      </div> 
    </div>
    <div *ngIf="authenticated">
      <div [matMenuTriggerFor]="changeaccountmenu" title="Change Account" class="account-box" *ngIf="accountsList.length > 1 && websiteName=='Parmed'">
        <img src="/assets/images/pharmacy-icon.png" alt="" />
        <p id="account" class="d-inline-block">
          <span class="text1">{{ defaultAccount.name }}</span>
          <br />
          <span *ngIf="websiteName == 'Parmed' && defaultAccount.name2" class="text1  ">{{ defaultAccount.name2 }}</span>
          <br *ngIf="websiteName == 'Parmed' && defaultAccount.name2" />
          <span>{{ defaultAccount.accountNum }}</span>
        </p>
        <a>
          <span *ngIf="accountsList.length > 1" class="caret blue-caret cursor-pointer d-inline-block margin-top-15"></span>
        </a>
        <mat-menu #changeaccountmenu="matMenu" x-position="before">
          <button mat-menu-item *ngFor="let account of accountsList; let i = index" (click)="onSelectAccountClick(account)">
            <!-- <div class="container-fluid"> -->
            <div class="row-fluid">
              <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10" id="account-details-{{i+1}}">
                <div class="short-div">{{account.name}}</div>
                <div *ngIf="websiteName == 'Parmed' && account.name2 != null" class="short-div">{{account.name2}}</div>
                <div class="short-div" [attr.title]="account.accountNum">{{account.shipToNum}} </div>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                <div class="big-div">
                  <img *ngIf="account.hasCart" src="/assets/images/icons8-shopping-cart-24 green.png" />
                  <img *ngIf="!account.hasCart" src="/assets/images/icons8-shopping-cart-24 grey.png" />
                </div>
              </div>
            </div>
          </button>
        </mat-menu>
      </div>
      <div class="cursor-text account-box" *ngIf="accountsList.length == 1 && websiteName=='Parmed'">
        <img src="/assets/images/pharmacy-icon.png" alt="" />
        <p id="account" class="d-inline-block">
          <span class="text1">{{ defaultAccount.name }}</span>
          <br />
          <span>{{ defaultAccount.accountNum }}</span>
        </p>
      </div>
      <div class="address-box" *ngIf="websiteName=='Parmed'">
        <img src="/assets/images/location-icon.png" alt="" />
        <p id="address">
          <span *ngIf="defaultAccount && defaultAccount.addr1">{{ defaultAccount.addr1 }}
          </span>
          <br />
          <span *ngIf="defaultAccount && defaultAccount.city">{{ defaultAccount.city }},</span>
          <span *ngIf="defaultAccount && defaultAccount.state">{{ defaultAccount.state }}
          </span>
          <span *ngIf="defaultAccount && defaultAccount.zip">{{ defaultAccount.zip }}
          </span>
        </p>
      </div>
      <div class="pull-right">
        <div *ngIf="websiteName == 'Parmed'" class="pull-left padding-16" id="website-help" (click)="routeClick(routes.websiteHelp)">
          <img height="36px" width="38px" src="/assets/images/question-mark.png" class="vertical-middle padding-right-5" />
          <div class="d-inline-block padding-left-0">Website Help</div>
        </div>
        <div *ngIf="websiteName == 'Major' && authenticated" style="display: none;" class="center-align pull-left padding-16" id="website-help" (click)="routeClick(routes.websiteMajorHelp)">
          <img height="36px" width="38px" src="/assets/images/question-mark.png" class="vertical-middle padding-right-5" />
          <div class="d-inline-block padding-left-0">Website Help</div>
        </div>

        <div class="center-align" id="sign-in" *ngIf="!authenticated" (click)="onSignInClick()">
          <img height="36px" width="38px" src="/assets/images/sign-in-logo.png" class="vertical-middle padding-right-5" />
          <div class="d-inline-block padding-left-0">Sign In</div>
        </div>
         <div class="pull-left padding-16" *ngIf="authenticated && websiteName=='Major'">
        <div *ngIf="authenticated && websiteName=='Major'" [routerLinkActive]="['active-menu-item']" (click)="getPromotion(); getCategories();">
                <span id="nav-shop" [matMenuTriggerFor]="shopmenu" class="menuTitle cursor-pointer">Shop <img class="arrowBlue"
                        src="../../../assets/images/Major/arrow-blue.png"/></span>
        </div>
            <mat-menu #shopmenu="matMenu">
                <button id="nav-categories" *ngIf="websiteName == 'Major'" mat-menu-item 
                (click)="shopMenu.closeMenu()" [matMenuTriggerFor]="categoryMenu" (click)="routeClick(routes.categories)">Categories</button>
                <button id="nav-promotions-menu" *ngIf="hasPromotions" mat-menu-item (click)="shopMenu.closeMenu()"
                    [matMenuTriggerFor]="promotionMenu"  (click)="routeClick(routes.promotions)">Promotions</button>
                <button id="nav-promotions" *ngIf="!hasPromotions" mat-menu-item (click)="shopMenu.closeMenu()"
                (click)="routeClick(routes.promotions)">Promotions</button>
                <button id="nav-favorites" mat-menu-item (click)="routeClick(routes.favorites)">Favorites</button>
                <button id="nav-watchList" mat-menu-item (click)="routeClick(routes.watchList)">Watchlist</button>
               
                <button id="nav-recent-order" mat-menu-item (click)="routeClick(routes.producthistory)">Recently
                    Ordered</button>
               
                <button id="nav-quick-order" mat-menu-item (click)="routeClick(routes.quickOrder)">Quick Order</button>
              
            </mat-menu>
            <mat-menu #promotionMenu="matMenu">
                <button mat-menu-item *ngFor="let promotion of promotions; let i = index" id="promotion-{{i+1}}"
                    (click)="onPromotionClick(promotion);routeClick(this.routes.promotionDetails + promotion.categoryId);">{{promotion.name}}</button>
            </mat-menu>
            <mat-menu #categoryMenu="matMenu">
                <button mat-menu-item *ngFor="let category of categories; let i = index" id="category-{{i+1}}"
                    (click)="routeClick(this.routes.categoryDetails + category.itemListID)">{{category.displayLabel}}</button>
            </mat-menu>
            </div> 
            <div class="pull-left padding-16" *ngIf="authenticated && websiteName=='Major'">
            <div  [routerLinkActive]="['active-menu-item']">
                <span id="nav-my-account" [matMenuTriggerFor]="myaccountmenu" class="menuTitle cursor-pointer">My Account  <img
                      class="arrowBlue"  src="../../../assets/images/Major/arrow-blue.png"/></span>
                </div>
            <mat-menu #myaccountmenu="matMenu">
                <button id="nav-pay-invoice" *ngIf='websiteName=="Major"' mat-menu-item
                    (click)="routeClick(routes.payInvoices)">Pay My Invoices</button>
              
                <button id="nav-order-history" mat-menu-item (click)="routeClick(routes.orderHistory)">Order History</button>
          
                <button id="nav-search-dscsa" mat-menu-item (click)="routeClick(routes.searchTransactionData)" *ngIf = "!ifDatePresent">Search
                    DSCSA</button>

                <button id="nav-search-dscsa" mat-menu-item [matMenuTriggerFor]="searchDSCSA" *ngIf = "ifDatePresent">Search
                    DSCSA</button>
                    <mat-menu #searchDSCSA="matMenu">
                     
                       
                        <button mat-menu-item (click)="routeClick(routes.searchTransactionData)"  *ngIf = "ifDatePresent && websiteName == 'Major'">Lot-based</button>
                        <button id="nav-dscsa-reporting" mat-menu-item (click)="routeClick(routes.dscsaReporting)"   *ngIf = "ifDatePresent && websiteName == 'Major'">Serialized</button>
                     
                    </mat-menu>
                  
                <button id="nav-manage-cards" mat-menu-item (click)="routeClick(routes.creditCards)">Manage Credit
                    Cards</button>
                <button *ngIf="isSubscriptionEnabled" id="nav-my-subscriptions" mat-menu-item (click)="routeClick(routes.subscription)">Subscriptions</button>
              
            </mat-menu>
            </div>

        <div class="pull-left padding-16 " id="sign-in" *ngIf="websiteName=='Parmed'">
          <img height="36px" width="36px" src="/assets/images/sign-in-logo.png" class="vertical-sub padding-right-5" />
          <div class="d-inline-block padding-left-0" id="menu" [matMenuTriggerFor]="menu">
            <span class="name text-left">Hello,</span>
            <br />
            <span class="name user-name" title="{{ userDetail.firstName }}">{{ userDetail.firstName }}</span>
          </div>
          <span class="caret blue-caret padding-bottom-22" id="menu" [matMenuTriggerFor]="menu"></span>
        </div>
        <div class="pull-left padding-16 " id="sign-in" *ngIf="websiteName=='Major'">
           <span class="profile-icon-wrapper" style="margin-top: -3px;">
          <mat-icon>person_outline</mat-icon>
      </span>
          
        </div>
        <div class="pull-left padding-16 custom-sign-box" id="sign-in" *ngIf="websiteName=='Major'"> 
          <div class="profile-display padding-left-0 cursor-pointer" id="menu" [matMenuTriggerFor]="menu">
            <span class="name text-left menuTitle mt-10">Hello,</span>
            <br />
            <span class="name user-name menuTitle mt-10" title="{{ userDetail.firstName }}">{{ userDetail.firstName }}</span>
          
          <span  style="margin-left: 5px;margin-top: 3px;"   class="padding-bottom-22" id="menu" [matMenuTriggerFor]="menu"><img class="arrowBlue"
                        src="../../../assets/images/Major/arrow-blue.png"/></span>
                        </div>
        </div>

        <div class="pull-left padding-16" id="cart">
           <img   *ngIf="websiteName=='Parmed'" height="36px" width="38px" src="/assets/images/cart-icon.png" class="vertical-middle cursor-pointer" [routerLink]="[routes.shoppingCart]"
          />
          <span class="item-count menuTitle" *ngIf="orderCount > -1 && websiteName=='Parmed'">{{ orderCount }}
          </span>
 <img  *ngIf="websiteName=='Major'" height="20px" width="20px" src="/assets/images/cart-icon.png" class="vertical-middle cursor-pointer" [routerLink]="[routes.shoppingCart]"
          />
          <span  class="item-major-count menuTitle" *ngIf="orderCount > -1 && websiteName=='Major'">{{ orderCount }}
          </span>
          <div class="d-inline-block padding-left-6 "  [ngClass]="{'menuTitle':websiteName=='Major'}">
           <span *ngIf="websiteName=='Major'">My </span>Cart
          </div>
        </div>
        <mat-menu #menu="matMenu" overlapTrigger="false">
          <button id="change-web-setting" mat-menu-item color="accent" (click)="routeClick(routes.changeAccountSettings)">
            Web Account Settings
          </button>
          <button id="change-password" mat-menu-item color="accent" (click)="routeClick(routes.changePassword)">
            Change Password
          </button>
          <button id="change-security-question" mat-menu-item color="accent" (click)="routeClick(routes.updateSecurityQuestion)">
            Change Security Questions
          </button>
          <button id="sign-out" mat-menu-item color="accent" (click)="onLogOffClick()">
            Sign Out
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</header>

<header  id="parmed-header" class="header" *ngIf="websiteName=='Major' && authenticated">
  
  <div class="header-right" style="padding-top: 0px !important"  [ngClass]="{'user-info': websiteName === 'Major' && authenticated,'paddingMajor': websiteName === 'Major'}" >
    
    <div *ngIf="authenticated">
      <div [matMenuTriggerFor]="changeaccountmenu" title="Change Account" style="width: 320px !important;" class="account-box-major" *ngIf="accountsList.length > 1">
        <div style="margin-left: 15px;">
<img src="/assets/images/location-icon.png" alt="" style="width: 20px;height: 20px;margin-top: 15px; " />
        <p id="accountMajor" class="d-inline-block">
          <span class="text1 txtMajor nameFont">{{ defaultAccount.name }}</span>
            <span class="text1 txtMajor nameFont">{{ defaultAccount.accountNum }}</span>
          <br>
          <span *ngIf="defaultAccount && defaultAccount.addr1" class="txtMajor address-font">{{ defaultAccount.addr1 }}
          </span>
          <span *ngIf="defaultAccount && defaultAccount.city" class="txtMajor address-font">{{ defaultAccount.city }},</span>
          <span *ngIf="defaultAccount && defaultAccount.state" class="txtMajor address-font">{{ defaultAccount.state }}
          </span>
          <span *ngIf="defaultAccount && defaultAccount.zip" class="txtMajor address-font">{{ defaultAccount.zip }}
          </span>
        </p>
        </div>
        <a>
          <span *ngIf="accountsList.length > 1" class="cursor-pointer d-inline-block margin-top-15"  ><img
                        src="../../../assets/images/Major/arrow-blue.png" class="arrowBlue"/></span>
        </a>
        <mat-menu #changeaccountmenu="matMenu" x-position="before">
          <button mat-menu-item *ngFor="let account of accountsList; let i = index" (click)="onSelectAccountClick(account)">
            <!-- <div class="container-fluid"> -->
            <div class="row-fluid">
              <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10" id="account-details-{{i+1}}">
                <div class="short-div">{{account.name}}</div>
                <div *ngIf="websiteName == 'Parmed' && account.name2 != null" class="short-div">{{account.name2}}</div>
                <div class="short-div" [attr.title]="account.accountNum">{{account.shipToNum}} </div>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                <div class="big-div">
                  <img *ngIf="account.hasCart" src="/assets/images/icons8-shopping-cart-24 green.png" />
                  <img *ngIf="!account.hasCart" src="/assets/images/icons8-shopping-cart-24 grey.png" />
                </div>
              </div>
            </div>
          </button>
        </mat-menu>
      </div>
       <div class="account-box-major" *ngIf="accountsList.length == 1">
        <div style="margin-left: 15px;">
        <img src="/assets/images/location-icon.png" alt="" style="width: 20px;height: 20px;margin-top: 15px; " />
        <p id="accountMajor" class="d-inline-block">
          <span class="text1 txtMajor nameFont">{{ defaultAccount.name }}</span>
            <span class="text1 txtMajor nameFont">{{ defaultAccount.accountNum }}</span>
          <br>
          <span *ngIf="defaultAccount && defaultAccount.addr1" class="txtMajor address-font">{{ defaultAccount.addr1 }}
          </span>
          <span *ngIf="defaultAccount && defaultAccount.city" class="txtMajor address-font">{{ defaultAccount.city }},</span>
          <span *ngIf="defaultAccount && defaultAccount.state" class="txtMajor address-font">{{ defaultAccount.state }}
          </span>
          <span *ngIf="defaultAccount && defaultAccount.zip" class="txtMajor address-font">{{ defaultAccount.zip }}
          </span>
        </p>
        </div>
      </div> 
      
           <div class="pull-right">
        <div class="pull-left padding-16 cursor-pointer" style="margin-top: 15px;">
          <span id="nav-priceChange" class="priceChange" (click)="openDialog()"><img   style="margin-right: 5px;" src="../../../assets/images/Major/dollar.png" />View price changes since you last signed in</span>
        
        </div>
         <div class="pull-right" >
          <div  id="cart">
           <form (submit)="onSearchProductSubmit()" *ngIf="authenticated">
        
              <div class="nav navbar-nav search-bar" *ngIf="websiteName=='Major'">
                <div class="navbar-form navbar-left search-fields" id="searchForm">
                    <div class="form-group search-form">
                        <input id="nav-search-major" type="search" [formControl]="searchProduct"
                            placeholder="Search products" maxlength= "100" (ngModelChange)="onSearchChange()"
                            [matAutocomplete]="auto" />
                             <img src="/assets/images/search-magnifying-glass-icon.png" id="nav-search" style="margin: 10px -30px;"   class="search-icon-major"
                    (click)="onSearchProductSubmit()" />
                        <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete">
                            <mat-option *ngFor="let option of productSuggestions" [value]="option">
                                {{option | uppercase}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                </div>
                
               
               
            </div>
        </form>
        </div>
        </div>
        </div>
    </div>
  </div>

</header>